import { useRef } from "react";
import style from "./SelectorWrapper.module.scss";
import CloseIcon from "../../../public/remove_back/magic_bg/close_cross.svg";
import CloseLine from "../../../public/remove_back/magic_bg/close_line.svg";
import useClickOutside from "../../../utils/hooks/useClickOutside";

function SelectorWrapper({ children, closeWrapper, isShown }) {
    const selectorRef = useRef(null);
    useClickOutside(selectorRef, e => closeWrapper(e));

    return (
        <div ref={selectorRef} className={`${style.block} ${style["selector-block"]} ${isShown ? style.visible : ""}`}>
            <CloseLine className={style.line} onClick={closeWrapper} />
            <CloseIcon className={style.close} onClick={closeWrapper} />
            {children}
        </div>
    );
}

export default SelectorWrapper;